<template>
  <div class="collage-photo-item">
    <div class="j-media"
         :class="{'cursor-pointer': !media.is_placeholder}"
         ref="sentinel"
         @click="onClick">
      <ImageMedia :media="media"/>
    </div>
    <CartActions :digital-item-id="digitalItemId"
                  :media="media"
                  :gallery="gallery"
                  v-if="isPaid"
                  v-show="!media.is_placeholder"/>
  </div>
</template>

<script>
import {observeMedia} from "@/utils/media";
import CartActions from "@/domain/media/galleries/medias/CartActions.vue";

import ImageMedia from "@/domain/media/galleries/components/ImageMedia.vue";

export default {
  name: "Media",
  components: {ImageMedia, CartActions},
  emits: ['select', 'firstVisible'],
  data() {
    return {
      loading: false,
      addedToCart: false
    }
  },
  props: {
    media: {
      type: [Object, Number],
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    isPaid: {
      type: Boolean,
      required: false
    },
    digitalItemId: {
      type: Number,
      required: false
    },
    gallery: {
      type: Object,
      required: false
    }
  },
  mounted() {
    this.observeMedia('.j-media', this.media.id)

    // if this is the first media and it's a placeholder, create an observer to fire media load
    if (this.index === 0 && this.media.is_placeholder) {
      this.createObserver()
    }

  },
  methods: {
    observeMedia,
    onClick() {
      if (this.media.is_placeholder) return
      this.$emit('select', this.index)
    },
    createObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      }
      this.observer = new IntersectionObserver(this.handleIntersect, options)
      this.observer.observe(this.$refs.sentinel)
    },
    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.$emit('firstVisible')
          this.observer.unobserve(this.$refs.sentinel)
        }
      })
    }
  }
}
</script>

